import { useRef, useCallback, useEffect } from 'react';

const isBrowser = () => typeof window !== "undefined";
function useTimeout({
  clearOnNewTimeout = false
} = {}) {
  const timeoutIds = useRef([]);
  const clearTimeout = useCallback(() => {
    if (!isBrowser()) {
      return;
    }
    if (timeoutIds.current.length > 0) {
      timeoutIds.current.forEach((id) => {
        window.clearTimeout(id);
      });
    }
  }, []);
  const setTimeout = useCallback(
    (callback, delay) => {
      if (!isBrowser()) {
        return;
      }
      if (clearOnNewTimeout) {
        clearTimeout();
      }
      const newId = window.setTimeout(() => {
        callback();
        timeoutIds.current = timeoutIds.current.filter((id) => id !== newId);
      }, delay);
      timeoutIds.current.push(newId);
    },
    [clearOnNewTimeout, clearTimeout]
  );
  useEffect(() => {
    return clearTimeout;
  }, [clearTimeout]);
  return {
    setTimeout,
    clearTimeout
  };
}

export { useTimeout };
//# sourceMappingURL=useTimeout.mjs.map
